import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from '@chakra-ui/react';
import { ADVISORS_LANDING_ILLUSTRATIONS } from '@src/components/sco/Advisors/AdvisorsLandingIllustrations/advisorsLandingIllustrations';
import { prefixLandingIllustrationIds, prepareLandingIllustrationSvg } from '@src/components/sco/GenericLP/prepareLandingIllustrationSvg';
import React from 'react';
export type AdvisorsIllustrationProps = BoxProps & {
  illustrationIndex: number;
};

/**
 * Renders an animated SVG feature illustration for the Advisors landing page.
 * Markup + CSS keyframes are ported from the advisors HTML mockup.
 */
export const AdvisorsIllustration: React.FC<AdvisorsIllustrationProps> = t0 => {
  const $ = _c(12);
  let boxProps;
  let illustrationIndex;
  if ($[0] !== t0) {
    ({
      illustrationIndex,
      ...boxProps
    } = t0);
    $[0] = t0;
    $[1] = boxProps;
    $[2] = illustrationIndex;
  } else {
    boxProps = $[1];
    illustrationIndex = $[2];
  }
  const rawSvg = ADVISORS_LANDING_ILLUSTRATIONS[illustrationIndex];
  if (!rawSvg) {
    return null;
  }
  let t1;
  if ($[3] !== illustrationIndex || $[4] !== rawSvg) {
    t1 = prefixLandingIllustrationIds(prepareLandingIllustrationSvg(rawSvg), `alp${illustrationIndex}-`);
    $[3] = illustrationIndex;
    $[4] = rawSvg;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const svg = t1;
  let t2;
  if ($[6] !== svg) {
    t2 = {
      __html: svg
    };
    $[6] = svg;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "& svg": {
        display: "block",
        width: "100%",
        height: "auto"
      }
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== boxProps || $[10] !== t2) {
    t4 = <Box bgColor="colorPalette.panel" border="1px solid" borderColor="colorPalette.border/50" borderRadius="2xl" dangerouslySetInnerHTML={t2} lineHeight={0} overflow="hidden" padding={4} width="full" css={t3} {...boxProps} />;
    $[9] = boxProps;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};